<template>
  <b-row>
    <b-col
      :lg="4" :offset-lg="4"
      :md="4" :offset-md="4"
    >
      <vue-form-generator
        :schema="schema"
        :model="form"
        :options="formOptions"
        ref="entityInformationForm"
      >
      </vue-form-generator>
      <new-entity></new-entity>
    </b-col>
  </b-row>
</template>
<script>
import VueFormGenerator from 'vue-form-generator';
import NewEntity from '@/components/entities/NewEntity';

export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    'new-entity': NewEntity,
  },
  props: {
    form: Object,
  },
  data() {
    return {
      formOptions: {
        validationErrorClass: 'invalid-input',
        validateAfterChanged: true,
        fieldIdPrefix: 'entity-',
      },
    };
  },
  watch: {
    entities() {
      this.setDefaultEntity();
    },
  },
  computed: {
    entities() {
      return this.$store.getters.entities;
    },
    schema() {
      const entityOptions = [];
      this.entities.forEach((entity) => {
        const entityData = { id: entity.id, name: entity.name };
        const option = { id: entityData, name: entity.name };
        entityOptions.push(option);
      });

      return {
        fields: [
          {
            type: 'select',
            label: 'Select the Entity for this transaction',
            model: 'entity',
            values: entityOptions,
            selectOptions: {
              hideNoneSelectedText: true,
            },
            styleClasses: 'col-md-12',
            required: true,
            validator: VueFormGenerator.validators.required,
          },
        ],
      };
    },
  },
  methods: {
    setDefaultEntity() {
      const lastEntity = this.entities[this.entities.length - 1];
      if (lastEntity) {
        this.form.entity = { id: lastEntity.id, name: lastEntity.name };
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/new_deal/components/entities/EntitySection.vue